import React, { useContext } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import styled from 'styled-components';
import { I18nContext } from 'i18n';
import { useForm } from 'react-hook-form';
import { Input, Button, Link } from 'components';
import { device } from 'utils/device';

const SearchForm = ({onSubmit}) => {
  const { translate } = useContext(I18nContext);
  const { register, handleSubmit } = useForm();

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row}>
          <Col>
            <Input
              type="text"
              placeholder={translate('search_placeholder')}
              name="globalSearch"
              autoFocus={true}
              ref={register({ required: true })}
              autoComplete="off"
            />
          </Col>
          <ButtonContainer md="2">
            <SearchButton type="submit">{translate('search')}</SearchButton>
          </ButtonContainer>
        </Form.Group>
        <Row>
          <Col md="10">
            <Paragraph>
              {translate('search_paragraph')}{' '}
              <Link href="/search/advanced">{translate('search_advanced')}</Link>.
            </Paragraph>
          </Col>
        </Row>
      </Form>
    </>
  );
};

const ButtonContainer = styled(Col)`
  text-align: center;

  @media ${device.mobileL} {
    margin-top: 1rem;
  }
`;

const SearchButton = styled(Button)`
  margin-top: unset;
  background-color: ${({ theme }) => theme.palette.primary[1]};
`;

const Paragraph = styled.p`
  margin-top: 1rem;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.grayscale[2]};
  text-align: center;

  > a {
    font-size: 1.2rem;
  }
`;

export default SearchForm;
